// Generated from App.tsx for a single page build. Do not edit.
// Generated by the server from the registered pages. Do not edit.
import { Routes, Route, useLocation } from 'react-router-dom';
import HomePage from "../pages/Home/Home";
const __wvcRoutePaths = ["/", "/HomePage", "/home"];
function AppRoutes() {
  const location = useLocation();
  const owned = new Set(["about", "aboutpage", "book-consultation", "bookconsultationpage", "cart", "cartpage", "certified-translation-services", "certifiedtranslationservicespage", "checkout", "checkoutpage", "consultation", "consultation-confirmed", "consultationconfirmedpage", "consultationpage", "family-mediation-services", "familymediationcreolepage", "familymediationservicespage", "foreign-legal-consulting", "foreignlegalconsultingpage", "frenchservicespage", "home", "homepage", "immigration-services", "immigrationservicespage", "medyasyon-fanmi-an-kreyol", "my-account", "myaccountpage", "post", "publishing-services", "publishingservicespage", "real-estate-services", "realestateservicespage", "remote-online-notary-ron", "remoteonlinenotarypage", "rise-in-america-about-us", "rise-in-america-contact", "rise-in-america-get-involved", "rise-in-america-home", "rise-in-america-our-programs", "riseinamericaaboutuspage", "riseinamericacontactpage", "riseinamericagetinvolvedpage", "riseinamericahomepage", "riseinamericaourprogramspage", "services-en-francais", "stegy-tours", "stegytourspage", "tax-preparation", "taxpreparationpage"]);
  const segment = (location.pathname.split('/')[1] || '').toLowerCase();
  return <Routes key={owned.has(segment) ? segment : '/'}>
      <Route path={__wvcRoutePaths[0]} element={<HomePage />} />
      <Route path={__wvcRoutePaths[1]} element={<HomePage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      <Route path={__wvcRoutePaths[2]} element={<HomePage />} />
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
      
    </Routes>;
}
function App() {
  return <>
      <AppRoutes />
    </>;
}
export default App;
